export default __webpack_public_path__ + "static/media/employees-16px.fda0b228.svg";